// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f679600","879":"245d9d0e"}[chunkId] + ".chunk.js";
};